import { scope } from '../../constants';

export const GET_COMPANY = `${scope}GET_COMPANY`;
export const SET_COMPANY = `${scope}SET_COMPANY`;
